import styled from '@emotion/styled';
import { black } from 'Styles/colors';

export const StyledIntro = styled.div`
  .MuiTextField-root {
    margin-bottom: 1rem;
    background-color: rgba(255, 255, 255, 0.95);
    border-radius: 0.5rem;
  }

  .MuiOutlinedInput-root {
    border-radius: 0.5rem;
    color: #333;
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: ${black._38};
  }

  .MuiInputLabel-root {
    color: #555;
  }
`;
